import { validateDecimalNumber } from '@gocanvas/client/dist/lib/inputValidation.jsx'
import { validateMinRange, validateMaxRange } from '@gocanvas/client/dist/lib/utils.jsx'


export const validateMinMaxRange = (value, minimum, maximum, property) => {
  const meetsMin = validateMinRange(minimum, value)
  const meetsMax = validateMaxRange(maximum, value)
  const meetsMinMax = validateMinRange(minimum, maximum)


  if (property === 'minimum' && !meetsMin) {
    return `Input must be less than or equal to ${value}`
  }

  if (property === 'maximum' && !meetsMax) {
    return `Input must be greater than or equal to ${value}`
  }

  if (!value && property === 'minimum' && !meetsMinMax) {
    return `Input must be less than or equal to ${maximum}`
  }

  if (!value && property === 'maximum' && !meetsMinMax) {
    return `Input must be greater than or equal to ${minimum}`
  }
}

export const validateMinMaxNumber = (field, property) => {
  const { minimum, maximum, mask } = field

  const wholeIntergerRegex = /^-?\d+$/
  const isValidInteger = wholeIntergerRegex.test(field.default)
  const isValidMin = wholeIntergerRegex.test(minimum)
  const isValidMax = wholeIntergerRegex.test(maximum)

  if (mask === 0 && field.default && !isValidInteger) {
    return 'Only whole numbers are allowed'
  }
  if (property === 'minimum' && minimum && !isValidMin) {
    return 'Input is invalid'
  }
  if (property === 'maximum' && maximum && !isValidMax) {
    return 'Input is invalid'
  }
  return validateMinMaxRange(
    parseInt(field.default, 10),
    parseInt(minimum, 10),
    parseInt(maximum, 10),
    property
  )
}
export const validateMinMaxDecimal = (field, property) => {
  const { minimum, maximum, mask } = field
  const isValidMinValDecimal = validateDecimalNumber(minimum, mask)
  const isValidMaxValDecimal = validateDecimalNumber(maximum, mask)

  if (property === 'minimum' && minimum && !isValidMinValDecimal) {
    return 'Input is invalid'
  }
  if (property === 'maximum' && maximum && !isValidMaxValDecimal) {
    return 'Input is invalid'
  }
  return validateMinMaxRange(
    parseFloat(field.default),
    parseFloat(minimum),
    parseFloat(maximum),
    property
  )
}